export default {
  // 插件配置
  plugins: 'advlist code link lists table image placeholder',
  // 菜单配置
  menubar: 'edit format table',
  // 工具栏配置
  toolbar: 'formatselect | bold italic underline strikethrough forecolor backcolor | ' +
    'alignleft aligncenter alignright alignjustify bullist numlist | ' +
    'image link',
  // 状态栏
  statusbar: false,
  // 皮肤
  skin: false,
  // 多语言
  language: 'zh_CN',
  // 默认样式
  content_css: false,
  // fontSize配置
  fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
  // fontFamily配置
  font_formats: 'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
  // 自定义css
  content_style: '',
  // 上传文件类型
  file_picker_types: 'image',
  convert_urls: false
}